; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Utility/passClickToGenesysBtn',['promise-polyfill'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('promise-polyfill')) :
    console && console.error('PassClickToGenesysBtn loaded in a wrong way');
}(this/* window */, function () {
    function PassClickToGenesysBtn() {
        Object.defineProperty(this, 'selector', { enumerable: !0, configurable: !0, writable: !0, value: '.pass-click-to-genesys-btn' });
    }

    PassClickToGenesysBtn.prototype.installAsync = function installAsync() {
        return new Promise((function(resolve, reject) {
            try {
                // track all elements which received subscribers
                var installedElements = this.install();
                // pass elements through the promise, in case if anyone will be interested in them
                resolve(installedElements);
            } catch (e) {
                reject(e);
            }
        }).bind(this));
    }

    PassClickToGenesysBtn.prototype.install = function install() {
        // find and convert into an Array, because I want to pass it back. 
        var elements = [].slice.call(document.querySelectorAll(this.selector));

        elements.forEach(function (element) {
            // make the element to be navigable via a keyvoard
            if (element.getAttribute('tabindex') === null) {
                element.setAttribute('tabindex', '0');
            }

            if (element.preserve_clickHandler_passClickToGenesysBtn instanceof Function) {
                element.removeEventListener('click', element.preserve_clickHandler_passClickToGenesysBtn);
            }

            if (element.preserve_keyUp_passClickToGenesysBtn instanceof Function) {
                element.removeEventListener('keyup', element.preserve_keyUp_passClickToGenesysBtn);
            }

            var clickGenesysFn = this.clickGenesys.bind(this);
            var pressGenesysFn = this.pressGenesys.bind(this);

            element.addEventListener('click', clickGenesysFn);
            element.addEventListener('keyup', pressGenesysFn);

            element.preserve_clickHandler_passClickToGenesysBtn = clickGenesysFn;
            element.preserve_keyUp_passClickToGenesysBtn = pressGenesysFn;
        }, this);

        return elements.slice();
    }

    PassClickToGenesysBtn.prototype.clickGenesys = function clickGenesys() {

        // find genesys btn
        var channelSelectionEl = document.querySelector('.cs-callback');
        if (channelSelectionEl) {
            // trigger click event
            channelSelectionEl.click();
        }
    }

    PassClickToGenesysBtn.prototype.pressGenesys = function pressGenesys(event) {
        // skip event if it is not Enter key
        if (event.type !== 'keyup' || event.keyCode !== 13) {
            return;
        }

        this.clickGenesys();
    }


    return PassClickToGenesysBtn;
}));
